module.exports = __webpack_public_path__ + "img/heading_uk.718f9d52.svg";